import React from 'react';
import './../styles/LoadingSpinner.css';

/**
 * A reusable loading spinner overlay that can be used across the app.
 */
const LoadingSpinner = () => {
  return (
    <div className="loading-spinner-overlay">
      <div className="loading-spinner" />
    </div>
  );
};

export default LoadingSpinner;
